module.exports = __webpack_public_path__ + "img/xin.07ea47ec.png";